/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Minus Circle",
  size: 20
}

const SvgMinusCircle = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <circle fill="none" strokeWidth={1.1} cx={9.5} cy={9.5} r={9} />
    <path fill="none" d="M5 9.5h9" />
  </Svg>
)

SvgMinusCircle.defaultProps = defaultProps
export default SvgMinusCircle
